import useTransition from "react-transition-state";
import { useUpdateEffect } from "react-use";
// import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import Icon from "../common/Icon";

const MyLectureCard = ({ loading, list }) => {
  const [{ status }, toggle] = useTransition({
    timeout: 500,
    initialEntered: true,
    preEnter: true,
  });

  const handleClickLecture = (lecture_id) => () => {
    window.open(`/lecture/view/${lecture_id}`, "_blank");
  };

  useUpdateEffect(() => {
    if (!loading) {
      toggle();
    }
  }, [loading]);

  return (
    <div className="card bg-white shadow col-span-6 md:col-span-4">
      <div className="card-body">
        <h2 className="card-title">내 강의</h2>
        {loading && (
          <div className="flex flex-row justify-center h-full">
            <Loader className={`basic-transition ${status}`} />
          </div>
        )}
        {!loading && list && (
          <>
            {list.length === 0 && (
              <div className="flex justify-center items-center m-auto">
                수강중인 강의가 없습니다.
              </div>
            )}
            {list.length > 0 && (
              <div className="border border-zinc-300 h-60 rounded-md border-opacity-80 px-1 overflow-y-scroll scrollbar-hide">
                <table className="table-fixed w-full border-separate border-spacing-x-2 border-spacing-y-1">
                  <thead>
                    <tr className="sticky top-0 bg-white">
                      <th className="text-sm font-bold pt-1 pb-2">강의명</th>
                      <th className="text-sm font-bold text-center pt-1 pb-2 w-16">
                        상태
                      </th>
                      <th className="text-sm font-bold text-center pt-1 pb-2 w-10">
                        보기
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map(({ title, coming, ing, past, _id: id }) => (
                      <tr key={id}>
                        <td className="text-ellipsis whitespace-nowrap overflow-hidden">
                          {title}
                        </td>
                        {coming && (
                          <td className="text-center">
                            <div className="badge badge-info text-white mt-1 place-self-start">
                              진행전
                            </div>
                          </td>
                        )}
                        {ing && (
                          <td className="text-center">
                            <div className="badge badge-accent text-white mt-1 place-self-start">
                              진행중
                            </div>
                          </td>
                        )}
                        {past && (
                          <td className="text-center">
                            <div className="badge opacity-30 mt-1 place-self-start">
                              완료
                            </div>
                          </td>
                        )}
                        <td className="text-center pt-1">
                          <button
                            className="btn btn-circle btn-primary btn-xs"
                            onClick={handleClickLecture(id)}
                          >
                            <Icon
                              name="chevron-right"
                              className="text-white"
                              size="sm"
                              width={3}
                            />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MyLectureCard;
